const COLLECTION_FIELDS = [
  "bodyBlocks",
  "attributions",
  "licensedAssets",
  "funding",
];

export const createEmptySystemCredits = () => ({
  version: 1,
  aboutText: "",
  bodyBlocks: [],
  attributions: [],
  licensedAssets: [],
  funding: [],
});

export const normalizeSystemCredits = (credits) => {
  const source = credits && typeof credits === "object" ? credits : {};

  return {
    ...source,
    version: 1,
    aboutText: typeof source.aboutText === "string" ? source.aboutText : "",
    bodyBlocks: Array.isArray(source.bodyBlocks) ? source.bodyBlocks : [],
    attributions: Array.isArray(source.attributions) ? source.attributions : [],
    licensedAssets: Array.isArray(source.licensedAssets)
      ? source.licensedAssets
      : [],
    funding: Array.isArray(source.funding) ? source.funding : [],
  };
};

const hasText = (value) => typeof value === "string" && value.trim().length > 0;

const isHttpUrl = (value) => {
  if (!hasText(value)) return true;

  try {
    const url = new URL(value);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch {
    return false;
  }
};

const addUrlError = (errors, path, value) => {
  if (!isHttpUrl(value)) {
    errors[path] = "Enter a valid http:// or https:// URL.";
  }
};

export const validateSystemCredits = (credits) => {
  const errors = {};
  const warnings = [];
  const source = credits && typeof credits === "object" ? credits : {};

  COLLECTION_FIELDS.forEach((field) => {
    if (!Array.isArray(source[field])) {
      errors[field] = "This value must be an array.";
    }
  });

  if (source.aboutText !== undefined && typeof source.aboutText !== "string") {
    errors.aboutText = "About text must be text.";
  }

  const attributions = Array.isArray(source.attributions)
    ? source.attributions
    : [];
  attributions.forEach((attribution, index) => {
    addUrlError(errors, `attributions.${index}.sourceUrl`, attribution?.sourceUrl);
  });

  const licensedAssets = Array.isArray(source.licensedAssets)
    ? source.licensedAssets
    : [];
  const requiredLicensedAssetFields = [
    ["title", "Title"],
    ["sourceUrl", "Source URL"],
    ["sourceLicenseName", "Source license name"],
    ["changesMade", "Changes made"],
  ];

  licensedAssets.forEach((asset, index) => {
    requiredLicensedAssetFields.forEach(([field, label]) => {
      if (!hasText(asset?.[field])) {
        errors[`licensedAssets.${index}.${field}`] = `${label} is required.`;
      }
    });

    ["sourceUrl"].forEach(
      (field) =>
        addUrlError(errors, `licensedAssets.${index}.${field}`, asset?.[field])
    );
    addUrlError(
      errors,
      `licensedAssets.${index}.modelViewer.src`,
      asset?.modelViewer?.src
    );

    const downloads = Array.isArray(asset?.downloads) ? asset.downloads : [];
    downloads.forEach((download, downloadIndex) => {
      addUrlError(
        errors,
        `licensedAssets.${index}.downloads.${downloadIndex}.url`,
        download?.url
      );
    });

    if (downloads.length > 0 && !hasText(asset?.modelViewer?.src)) {
      warnings.push(
        `Licensed asset ${index + 1} has downloads but no model preview URL.`
      );
    }
  });

  return {
    errors,
    warnings,
    isValid: Object.keys(errors).length === 0,
  };
};
